// ===== Mueblika · Ficha de producto =====

/* Burbuja del carrito: pinta el número real (leído de /cart.js) en
   la burbuja de la cabecera y quita el "oculto" al número y al
   círculo que lo envuelve. */
window.mbkPintarBurbuja = window.mbkPintarBurbuja || function (cart, emitir) {
  var n = (cart && cart.item_count) || 0;
  [
    '.cart-bubble__text-count',
    '[ref="cartBubbleCount"]',
    '[data-cart-count]',
    '.cart-count',
    '.cart-count-bubble',
    '.cart-icon-bubble',
    '[data-cart-item-count]'
  ].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      // Solo en elementos "hoja" (sin nada dentro): si un selector
      // genérico coincidiera con una caja del carrito, textContent
      // borraría todo su interior.
      if (el.children.length) return;
      el.textContent = n;
      el.classList.toggle('hidden', n === 0);
      if (n > 0) el.removeAttribute('hidden');
    });
  });
  // El círculo que envuelve el número (en Horizon lleva "visually-hidden"
  // cuando el carrito está vacío)
  document.querySelectorAll('.cart-bubble, [ref="cartBubble"]').forEach(function (el) {
    el.classList.toggle('visually-hidden', n === 0);
    if (n > 0) {
      el.classList.remove('hidden');
      el.removeAttribute('hidden');
    }
  });
  // Ya NO se dispara el evento "cart:update" de Horizon: sin el HTML
  // nuevo del carrito que espera, Horizon redibujaba el carrito
  // lateral vacío al añadir. "emitir" se deja por compatibilidad.
};
window.mbkRefrescarBurbuja = window.mbkRefrescarBurbuja || function () {
  return fetch('/cart.js', { cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (cart) { window.mbkPintarBurbuja(cart, true); })
    .catch(function () {});
};

/* Carrito lateral y página del carrito: los redibuja con el propio
   renderizador de secciones de Horizon (@theme/section-renderer), igual
   que hace Horizon cuando el carrito cambia desde fuera. Así se
   actualizan sin cerrarse ni romperse. Antes se sustituía la sección
   entera con outerHTML, y eso cerraba el panel o lo dejaba sin
   actualizar. */
window.mbkRefrescarCarrito = window.mbkRefrescarCarrito || function () {
  var ids = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
    var id = el.getAttribute('data-section-id');
    if (id && ids.indexOf(id) === -1) ids.push(id);
  });
  var cajonVacio = !!document.querySelector('#cart-drawer [data-cart-drawer-empty], #cart-drawer .cart-drawer--empty');

  var redibujar = !ids.length ? Promise.resolve() :
    import('@theme/section-renderer')
      .then(function (m) {
        return Promise.all(ids.map(function (id) {
          var enCajon = !!document.querySelector('#cart-drawer cart-items-component[data-section-id="' + id + '"]');
          return m.sectionRenderer.renderSection(id, {
            cache: false,
            mode: enCajon ? 'hydration' : 'full',
            injectStylesheet: enCajon && cajonVacio
          });
        }));
      })
      .catch(function () { /* si falla, el producto ya está en el carrito */ });

  return redibujar.then(function () { return window.mbkRefrescarBurbuja(); });
};
(function () {
  document.querySelectorAll('.mbk-ficha').forEach(initFicha);

  function initFicha(root) {
    const galleryApi = initGallery(root);
    initVariantSelector(root, galleryApi);
    initQuantity(root);
    initAddToCart(root);
    initScrollToQuote(root);
    initLightbox();
    initTrustStats(root);
  }

  /* ---------- Círculos de confianza: efecto de "carga" al hacer
     scroll hasta ellos, en vez de aparecer ya llenos de golpe ---------- */
  function initTrustStats(root) {
    const circles = root.querySelectorAll('[data-mbk-trust-target]');
    if (!circles.length) return;

    if (!('IntersectionObserver' in window)) {
      // Navegadores muy antiguos sin soporte: los rellena directamente,
      // sin animación, para que al menos se vea el dato correcto
      circles.forEach((c) => { c.style.strokeDashoffset = c.dataset.mbkTrustTarget; });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const circle = entry.target;
          // Pequeño margen para que el navegador termine de pintar el
          // estado inicial (vacío) antes de animar al valor final
          requestAnimationFrame(() => {
            circle.style.strokeDashoffset = circle.dataset.mbkTrustTarget;
          });
          obs.unobserve(circle);
        });
      },
      { threshold: 0.4 }
    );

    circles.forEach((circle) => observer.observe(circle));
  }

  /* ---------- Scroll al formulario de presupuesto ---------- */
  function initScrollToQuote(root) {
    const link = root.querySelector('[data-mbk-scroll-to-quote]');
    if (!link) return;

    link.addEventListener('click', (e) => {
      const target = document.querySelector('#mbk-quote-form');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      // Si el formulario no está en esta página, el enlace simplemente
      // no hace nada (evita que apunte a #mbk-quote-form si la página
      // no tiene la sección de presupuesto añadida).
    });
  }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    const slides = root.querySelectorAll('[data-mbk-slide]');
    const thumbs = root.querySelectorAll('[data-mbk-thumb]');
    const prevBtn = root.querySelector('[data-mbk-prev]');
    const nextBtn = root.querySelector('[data-mbk-next]');
    if (!slides.length) return null;

    let current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      current = index;
    }

    // Sustituye directamente la foto de la primera diapositiva (y su
    // miniatura) por la que venga de la variante — sin comparar nada,
    // así que no depende de que los nombres de archivo coincidan.
    function setPrimaryImage(src) {
      if (!src) return;
      // La foto de la variante llega como el ORIGINAL a tamaño completo
      // (varios MB). Se pide a 1200 px; el formato (AVIF/WebP) lo elige
      // Shopify solo, igual que con el resto de fotos del tema.
      src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
      goTo(0);
      const img = slides[0].querySelector('img');
      if (img) {
        img.src = src;
        img.srcset = '';
      }
      if (thumbs[0]) {
        const thumbImg = thumbs[0].querySelector('img');
        if (thumbImg) {
          thumbImg.src = src;
          thumbImg.srcset = '';
        }
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    return { goTo, setPrimaryImage };
  }

  /* ---------- Selector de variantes ---------- */
  function initVariantSelector(root, galleryApi) {
    const selects = root.querySelectorAll('[data-mbk-option-selector]');
    if (!selects.length) return;

    const variantScript = root.querySelector('[data-mbk-variants]');
    if (!variantScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      return;
    }

    const hiddenInput = root.querySelector('[data-mbk-variant-id]');
    const submitBtn = root.querySelector('[data-mbk-add-to-cart]');
    const submitLabel = root.querySelector('[data-mbk-add-label]');
    const priceWrap = root.querySelector('[data-mbk-price-wrap]');
    const priceMapScript = root.querySelector('[data-mbk-price-map]');

    let priceMap = {};
    if (priceMapScript) {
      try {
        priceMap = JSON.parse(priceMapScript.textContent);
      } catch (e) {
        priceMap = {};
      }
    }

    function getElementValue(el) {
      if (el.tagName === 'SELECT') return el.value;
      // Para los swatches de color (un <div> con botones dentro),
      // el valor seleccionado se guarda en data-selected-value
      return el.dataset.selectedValue || '';
    }

    function currentSelection() {
      return Array.from(selects)
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
        .map(getElementValue);
    }

    function findVariant(selection) {
      return variants.find((v) => {
        const options = [v.option1, v.option2, v.option3].filter(Boolean);
        return options.every((opt, i) => opt === selection[i]);
      });
    }

    function updateUI() {
      const selection = currentSelection();
      const match = findVariant(selection);

      if (!match) return;

      if (hiddenInput) hiddenInput.value = match.id;

      if (submitBtn) {
        submitBtn.disabled = !match.available;
      }
      if (submitLabel) {
        submitLabel.textContent = match.available ? 'Añadir al carrito' : 'Sin stock';
      }

      // Actualiza el precio mostrado con el de ESTA variante (y por la
      // cantidad elegida). Sin esto, el precio se quedaba fijo en el de
      // la variante con la que cargó la página.
      if (priceWrap && priceMap[match.id]) pintarPrecio(root);

      // Si la variante tiene una foto asignada en el admin, cambia la
      // galería a esa foto (comparando por URL de imagen, quitando el
      // parámetro de versión "?v=..." para que coincida siempre)
      if (galleryApi && match.featured_image && match.featured_image.src) {
        galleryApi.setPrimaryImage(match.featured_image.src);
      }
    }

    selects.forEach((selector) => {
      if (selector.tagName === 'SELECT') {
        selector.addEventListener('change', updateUI);
        return;
      }

      // Swatches de color: el clic en un botón interno marca ese
      // botón como activo y actualiza el valor seleccionado del
      // contenedor
      const swatchButtons = selector.querySelectorAll('[data-mbk-swatch]');
      const label = selector.parentElement
        ? selector.parentElement.querySelector('[data-mbk-color-label]')
        : null;

      swatchButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          swatchButtons.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          selector.dataset.selectedValue = btn.dataset.value;
          if (label) label.textContent = btn.dataset.label || btn.dataset.value;
          updateUI();
        });
      });
    });
  }

  /* ---------- Precio × cantidad ----------
     El precio de arriba se multiplica por la cantidad elegida. Con 2 o
     más, debajo sale el desglose («2 × 358,33 €»). El formato de euros
     es el de la tienda (Configuración > Tienda > Moneda), igual que el
     resto de precios de la web. */
  function formatMoney(cents, format) {
    const re = /\{\{\s*(\w+)\s*\}\}/;
    function separar(n, decimales, miles, coma) {
      const partes = (n / 100).toFixed(decimales).split('.');
      const entero = partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles);
      return entero + (partes[1] ? coma + partes[1] : '');
    }
    const m = (format || '').match(re);
    if (!m) return separar(cents, 2, '.', ',') + ' €';
    let v;
    switch (m[1]) {
      case 'amount': v = separar(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = separar(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': v = separar(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = separar(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = separar(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = separar(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': v = separar(cents, 2, ' ', '.'); break;
      default: v = separar(cents, 2, '.', ','); // amount_with_comma_separator
    }
    return format.replace(re, v);
  }

  function pintarPrecio(root) {
    const priceWrap = root.querySelector('[data-mbk-price-wrap]');
    const mapEl = root.querySelector('[data-mbk-price-map]');
    const idInput = root.querySelector('[data-mbk-variant-id]');
    if (!priceWrap || !mapEl || !idInput) return;
    if (!root._mbkPriceMap) {
      try { root._mbkPriceMap = JSON.parse(mapEl.textContent); } catch (e) { return; }
    }
    const datos = root._mbkPriceMap[idInput.value];
    if (!datos) return;

    const qtyInput = root.querySelector('.mbk-qty-input');
    let qty = parseInt(qtyInput ? qtyInput.value : '1', 10);
    if (!qty || qty < 1) qty = 1;
    const formato = mapEl.dataset.mbkMoneyFormat;
    const multiplica = qty > 1 && typeof datos.p === 'number';

    const precio = multiplica ? formatMoney(datos.p * qty, formato) : datos.price;
    const antes = datos.compare_at ? (multiplica ? formatMoney(datos.c * qty, formato) : datos.compare_at) : null;

    let html = antes
      ? '<s class="mbk-price__compare">' + antes + '</s> <span class="mbk-price__current mbk-price__current--sale">' + precio + '</span>'
      : '<span class="mbk-price__current">' + precio + '</span>';
    if (multiplica) html += '<span class="mbk-price__unidad">' + qty + ' × ' + datos.price + '</span>';
    priceWrap.innerHTML = html;
  }

  /* ---------- Cantidad ---------- */
  function initQuantity(root) {
    const minus = root.querySelector('[data-mbk-qty-minus]');
    const plus = root.querySelector('[data-mbk-qty-plus]');
    const input = root.querySelector('.mbk-qty-input');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', () => {
        const val = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.value = val;
        pintarPrecio(root);
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        const val = (parseInt(input.value || '1', 10) || 1) + 1;
        input.value = val;
        pintarPrecio(root);
      });
    }
    // Si escriben la cantidad a mano
    input.addEventListener('input', () => pintarPrecio(root));
    input.addEventListener('change', () => {
      if (!(parseInt(input.value, 10) >= 1)) input.value = 1;
      pintarPrecio(root);
    });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAddToCart(root) {
    const form = root.querySelector('.mbk-form');
    if (!form) return;

    const message = root.querySelector('[data-mbk-form-message]');
    const submitBtn = root.querySelector('[data-mbk-add-to-cart]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (submitBtn) submitBtn.disabled = true;
      if (message) {
        message.textContent = 'Añadiendo...';
        message.removeAttribute('data-state');
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            // Shopify devuelve status + description en caso de error
            throw new Error(data.description || 'No se pudo añadir el producto');
          }
          if (message) {
            message.textContent = 'Producto añadido al carrito';
            message.setAttribute('data-state', 'success');
          }
          document.dispatchEvent(
            new CustomEvent('mbk:cart:item-added', { detail: data })
          );

          // El fetch de /cart/add.js añade el producto bien, pero no
          // avisa a Shopify de que hay que refrescar el header (icono +
          // contador) ni el carrito lateral (si el tema tiene uno) —
          // eso solo pasa solo si usas el componente nativo de Horizon,
          // y este formulario es propio. Así que pedimos el HTML
          // actualizado de esas secciones y lo sustituimos, sin
          // recargar la página.
          window.mbkRefrescarCarrito();
        })
        .catch((err) => {
          if (message) {
            // Si falla la conexión, el navegador da un error técnico en
            // inglés ("Failed to fetch"): en ese caso se muestra un
            // mensaje propio en español
            message.textContent =
              err instanceof TypeError || !err.message
                ? 'No se pudo añadir el producto. Revisa tu conexión e inténtalo de nuevo.'
                : err.message;
            message.setAttribute('data-state', 'error');
          }
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  /* ---------- Lightbox (ampliar foto) ---------- */
  function initLightbox() {
    const lightbox = document.querySelector('[data-mbk-lightbox]');
    if (!lightbox) return;

    const img = lightbox.querySelector('[data-mbk-lightbox-img]');
    const closeBtn = lightbox.querySelector('[data-mbk-lightbox-close]');
    const prevBtn = lightbox.querySelector('[data-mbk-lightbox-prev]');
    const nextBtn = lightbox.querySelector('[data-mbk-lightbox-next]');

    let items = [];
    let current = 0;

    function collectItems() {
      // Se recalcula cada vez que se abre, así recoge también
      // triggers que se hayan añadido más adelante en la página
      // (ej: la franja de fotos destacadas)
      items = Array.from(document.querySelectorAll('[data-mbk-lightbox-trigger]'));
    }

    function show(index) {
      if (!items.length) return;
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      current = index;
      const trigger = items[current];
      img.src = trigger.dataset.fullSrc;
      img.alt = trigger.dataset.alt || '';
    }

    function open(startIndex) {
      collectItems();
      if (!items.length) return;
      show(startIndex);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-mbk-lightbox-trigger]');
      if (!trigger) return;
      collectItems();
      const index = items.indexOf(trigger);
      open(index >= 0 ? index : 0);
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', () => show(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(current + 1));

    lightbox.addEventListener('click', function (e) {
      // Cierra si se hace clic fuera de la imagen (en el fondo oscuro)
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }
})();